import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CommunicationsSidebar from '../../components/Communications/CommunicationsSidebar';
import {
  commMainClass,
  commPageWrapClass,
  commPanelBodyClass,
  commPanelHeaderClass,
  commShellClass,
} from '../../components/Communications/communicationsUi';
import { COMMUNICATIONS_BASE_PATH } from '../../models/MasterAdmin/communications';
import CommunicationsActivityPanel from './panels/CommunicationsActivityPanel';
import CommunicationsClickToCallPanel from './panels/CommunicationsClickToCallPanel';
import CommunicationsDashboardPanel from './panels/CommunicationsDashboardPanel';
import CommunicationsSettingsPanel from './panels/CommunicationsSettingsPanel';
import CommunicationsWebhooksPanel from './panels/CommunicationsWebhooksPanel';

const TAB_TITLES: Record<string, string> = {
  dashboard: 'Dashboard',
  activity: 'Call activity',
  calls: 'Place a call',
  webhooks: 'Webhook logs',
  settings: 'Settings',
};

function PanelHeader({ segment }: { segment: string }) {
  return (
    <header className={commPanelHeaderClass}>
      <div className="min-w-0">
        <h1 className="truncate text-sm font-semibold text-gray-900 dark:text-white sm:text-base">
          {TAB_TITLES[segment] || 'Exotel Calling'}
        </h1>
        <p className="text-xs text-gray-500 dark:text-gray-400">
          Exotel voice calls, IVR routing, and webhook monitoring
        </p>
      </div>
    </header>
  );
}

const CommunicationsHubPage: React.FC = () => {
  return (
    <div className={commPageWrapClass}>
      <div className={commShellClass}>
        <CommunicationsSidebar />
        <main className={commMainClass}>
          <Routes>
            <Route
              index
              element={
                <>
                  <PanelHeader segment="dashboard" />
                  <div className={commPanelBodyClass}>
                    <CommunicationsDashboardPanel />
                  </div>
                </>
              }
            />
            <Route
              path="activity"
              element={
                <>
                  <PanelHeader segment="activity" />
                  <div className={commPanelBodyClass}>
                    <CommunicationsActivityPanel />
                  </div>
                </>
              }
            />
            <Route
              path="calls"
              element={
                <>
                  <PanelHeader segment="calls" />
                  <div className={commPanelBodyClass}>
                    <CommunicationsClickToCallPanel />
                  </div>
                </>
              }
            />
            <Route
              path="webhooks"
              element={
                <>
                  <PanelHeader segment="webhooks" />
                  <div className={commPanelBodyClass}>
                    <CommunicationsWebhooksPanel />
                  </div>
                </>
              }
            />
            <Route
              path="settings"
              element={
                <>
                  <PanelHeader segment="settings" />
                  <div className={commPanelBodyClass}>
                    <CommunicationsSettingsPanel />
                  </div>
                </>
              }
            />
            <Route path="*" element={<Navigate to={COMMUNICATIONS_BASE_PATH} replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export { COMMUNICATIONS_BASE_PATH };
export default CommunicationsHubPage;
